﻿import React from 'react';
import { EpiContext } from '../../Shared/Scripts/Store/EpiContext/Types';
import VeilederIofDto from '../Models/VeilederIofDto';
import { connect } from 'react-redux';
import { VeilederIofAppState } from '../Store';
import { toggleVilkar } from '../Store/Valg/Actions';
import contentResolver, { resolveLinkCollection } from '../../Shared/Scripts/Utilities/EpiContentResolver';
import { ModalCompontent } from '../../Shared/Scripts/Components/ModalComponent';
import { updateZIndex } from '../../Shared/Scripts/Store/EpiContext/Actions';
import { BoksResultat } from '../../VeilederInntektOgFormue/Ids';
import { Resultat } from '../Models/Resultat/Resultat';
import { Modal } from '../Models/Resultat/Modal';
import { ArticleContentComponent } from '../../Shared/Scripts/Components/ArticleContentComponent';
import { Satser } from '../Utilities/SatserApi';
import * as VisningsLogikk from '../ResultatVisning';
import * as ValgTypes from '../Store/Valg/Types';
import { tilPengerFormat } from '../../Shared/Scripts/Utilities/Formatters';
import { updateLiveMessage } from '../../Shared/Scripts/Utilities/LiveMessage';

interface ResultOwnProps {
    resultat: Resultat;
    modal: Modal | undefined;
    satser: Satser;
    valg: ValgTypes.ValgState;
    eventId: string | null;
}

type ResultatProps = MapStateToProps & MapDispatchToProps & ResultOwnProps;

class ResultatComponent extends React.PureComponent<ResultatProps> {
    constructor(props: ResultatProps) {
        super(props);
        this.onVilkarClick = this.onVilkarClick.bind(this);
        this.onRequestClose = this.onRequestClose.bind(this);
    }

    onRequestClose(): void {
        this.props.updateZIndex(1);
        this.props.toggleVilkar();
    }
    componentDidMount(): void {
        updateLiveMessage();
    }

    onVilkarClick(event: React.MouseEvent): void {
        this.props.updateZIndex(2);
        this.props.toggleVilkar();
    }

    render(): JSX.Element {
        const { resultat, modal, visVilkar, epiContext, satser, valg, eventId } = this.props;
        const { locale, valuta } = this.props.epiContext;

        return (
            <div
                id={BoksResultat}
                className="c-veileder__panel c-veileder__panel--resultat c-veileder__panel--aubergine"
            >
                <div className="c-veileder__panel-row">
                    <div className="c-veileder__content">
                        <h3 className="c-veileder__content--header c-veileder__tittel c-veileder__tittel--resultat">
                            {contentResolver(epiContext, resultat.tittel)}
                        </h3>
                        <div className="c-veileder__content-vertical--textarea">
                            <p>{contentResolver(epiContext, resultat.ingress)}</p>
                        </div>
                    </div>
                    <div className="c-veileder__content c-veileder__content-vertical">
                        <div className="c-veileder__content--header c-veileder__content--indented">
                            <div className="c-veileder__resultat-tekst">
                                <span>{tilPengerFormat(VisningsLogikk.getSumOver(valg, satser), locale)}</span>
                                <span className="c-veileder__tekst c-veileder__tekst--postfix">
                                    {' '}
                                    {valuta}
                                </span>
                            </div>
                            <p className="c-veileder__tekst c-veileder__tekst--tett">
                                <span>{contentResolver(epiContext, resultat.dekorasjonOver)}</span>
                            </p>
                        </div>
                        {resultat.dekorasjonUnder && (
                            <div className="c-veileder__content--header c-veileder__content--indented">
                                <div className="c-veileder__resultat-tekst">
                                    <span>{tilPengerFormat(VisningsLogikk.getSumUnder(valg, satser), locale)}</span>
                                    <span className="c-veileder__tekst c-veileder__tekst--postfix">
                                        {' '}
                                        {valuta}
                                    </span>
                                </div>
                                <p className="c-veileder__tekst c-veileder__tekst--tett">
                                    <span>{contentResolver(epiContext, resultat.dekorasjonUnder)}</span>
                                </p>
                            </div>
                        )}
                    </div>
                </div>

                {!modal && (
                    <div className="c-veileder__panel-row">
                        <div className="c-veileder__content c-veileder__content--footer">
                            {resultat.lenke != null &&
                                resolveLinkCollection(
                                    epiContext,
                                    resultat.lenke,
                                    'c-veileder__linkwrapper c-veileder__resultatlink',
                                    'c-knapp c-knapp--lenke c-knapp--artikkellenke c-knapp--icon-after c-knapp--pil-hoyre-hvit',
                                )}
                        </div>
                        <div className="c-veileder__content" />
                    </div>
                )}

                {modal && (
                    <div className="c-veileder__panel-row">
                        <div className="c-veileder__content c-veileder__content--footer">
                            <button type="button" className="c-knapp c-knapp--lenke" onClick={this.onVilkarClick}>
                                {resultat.modalLenketekst != null &&
                                    contentResolver(epiContext, resultat.modalLenketekst)}
                            </button>
                            <ModalCompontent
                                isOpen={visVilkar}
                                onRequestClose={this.onRequestClose}
                                ariaCloseText={modal.ariaLabel}
                                eventId={eventId}
                            >
                                <ArticleContentComponent
                                    headerinnhold={contentResolver(epiContext, modal.tittel, 2)}
                                    contentinnhold={contentResolver(epiContext, modal.content, 2)}
                                />
                            </ModalCompontent>
                        </div>
                        <div className="c-veileder__content" />
                    </div>
                )}
            </div>
        );
    }
}

interface MapStateToProps {
    epiContext: EpiContext<VeilederIofDto>;
    visVilkar: boolean;
}

interface MapDispatchToProps {
    toggleVilkar: typeof toggleVilkar;
    updateZIndex: typeof updateZIndex;
}

export default connect(
    (state: VeilederIofAppState): MapStateToProps => {
        return {
            epiContext: state.epiContext,
            visVilkar: state.valg.visVilkar,
        };
    },
    { toggleVilkar, updateZIndex },
)(ResultatComponent);
